// extracted by mini-css-extract-plugin
export default {"back":"BackButton_back__EQmFT"};